export default __webpack_public_path__ + "static/media/successfactor.3ffc6a50.svg";